import {Model} from 'vue-mc';


/**
 * Contact model
 */
export default class BookingEditModel extends Model {


    // Default attributes that define the "empty" state.
    defaults() {
        return {
            ref_num: "",
            serviceDate: '',
            serviceTimeEnd: '',
            serviceTimeStart: '',
            location: '',
            location_address1: '',
            professional: '',
            nebs: [{
                key: 1,
                value: '',
                name: "",
                reference: "",
                gender: "",
                when: "",
                where: "",
                professional: ""

            }]
        }
    }

}


// WEBPACK FOOTER //
// ./src/models/bookingEditModel.js